import React from 'react';

import cs from 'classnames';

import {FormErrorsProps, withFormErrors} from './with-form-errors';

interface Props extends FormErrorsProps {
  className?: string;
  errorSelector?: (
    formErrors: FormErrorsProps['formErrors']
  ) => Array<string> | void;
}

export const ShowNonFieldFormErrors = withFormErrors(
  function ShowNonFieldFormErrors({
    formErrors,
    errorSelector,
    className,
  }: Props) {
    const errors =
      errorSelector != null
        ? errorSelector(formErrors) ?? []
        : formErrors.non_field_errors ?? [];

    return errors.length == 0 ? null : (
      <div className={cs(className)}>
        {errors.map((error) => (
          <p className="alert alert-danger" key={error}>
            {error}
          </p>
        ))}
      </div>
    );
  }
);
